import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, ModalOverlay } from '@chakra-ui/react';
import { useEffect } from 'react';
import { SupportEmail } from '../utils/surveyStatusSchemas';

const LogoutModal = () => {
    useEffect(() => {
        sessionStorage.clear();
    }, []);

    const href = `mailto:${SupportEmail}?subject=Reopen%20Survey%20Request`;

    return (
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        <Modal isOpen={true} onClose={() => {}}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>You&apos;ve been logged out</ModalHeader>
                <ModalBody>
                    If you were unable to submit your survey, <b>request it to be reopened</b> using the button below.
                </ModalBody>
                <ModalBody>
                    If you submitted your survey successfully - you may close this tab.
                </ModalBody>
                <ModalFooter>
                    {/* TODO: Add body with pertinent information about the user */}
                    <Button as="a" href={href}>
                        Request to Reopen Survey
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default LogoutModal;
